/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // API_BASE_URL: "https://stooge-api.mira-hr.com/api",    // url for client stooge
  // FE_URL: "https://stooge.mira-hr.com",               // url for client stooge
  // API_BASE_URL: "http://localhost:1337/api",
  // FE_URL: "http://localhost:1337",
  API_BASE_URL: "https://api.mira-hr.com/api",
  FE_URL: "https://api.mira-hr.com",
  // API_BASE_URL: "https://hr-mis-api-test2.onrender.com/api",    // url for local Strapi-based Backend
  // FE_URL: "https://hr-mis-api-test2.onrender.com",               // url for deployed Angular-based Frontend
  // PostHog analytics (project token is public, client-side by design)
  posthogKey: "phc_QngUlUg9NBuE6AKqYqqjlLGV6uNSsOkH2H3TYsKSgwS",
  posthogHost: "https://us.i.posthog.com",
};
